import React, { useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { NavItem, NavLink, TabsWrap } from "../../../../shared/components/Tabs";
import { scrollbarStyles } from "../../../../utils/palette";
import InvoicesTable from "./InvoicesTable";
import ReceiptsTable from "./ReceiptsTable";

const TableTabs = ({ invoices, receipts, isAndroid, isIos }) => {
  const { t } = useTranslation("common");
  
  // Hide invoices tab for Android/iOS users
  const showInvoices = !isAndroid && !isIos;
  
  // Set initial active tab - use receipts tab if invoices are hidden
  const [activeKey, setActiveKey] = useState(showInvoices ? "1" : "2");

  return (
    <Tab.Container activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
      <TabsWrap>
        <Nav className="nav-tabs">
          {showInvoices && (
            <NavItem
              id="invoices-tab"
              $active={activeKey == "1"}
            >
              <NavLink eventKey="1" name="invoices-link">
                {t("invoices")}
              </NavLink>
            </NavItem>
          )}
          <NavItem
            id="receipts-tab"
            $active={activeKey == "2"}
          >
            <NavLink eventKey="2" name="receipts-link">
              {t("receipts")}
            </NavLink>
          </NavItem>
        </Nav>

        <Tab.Content>
          {showInvoices && (
            <TabPane eventKey="1">
              <InvoicesTable invoices={invoices} />
            </TabPane>
          )}
          <TabPane eventKey="2">
            <ReceiptsTable receipts={receipts} />
          </TabPane>
        </Tab.Content>
      </TabsWrap>
    </Tab.Container>
  );
};

export const TabPane = styled(Tab.Pane)`
  ${scrollbarStyles};
  //height: calc(var(--window-height, 100vh) - 180px);
  overflow: auto;
`;

export default TableTabs;
